<template>
    <div>
        <send-list-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addSendList">
                    <i class="far fa-file"></i>
                </button>
                <button class="btn btn-secondary" v-if="canImport" @click="onImport">
                    <i class="fas fa-file-import"></i>
                </button>
            </template>
        </send-list-table>
        <quick-bulk-message></quick-bulk-message>
        <email-bulk-message-dialog></email-bulk-message-dialog>
    </div>
</template>

<script>
  import eventBus from "../../../event-bus";
  import SendListTable from "../../../components/send-list/table";
  import QuickBulkMessage from "../../../components/bulk-message/quick-message";
  import EmailBulkMessageDialog from "../../../components/email-bulk-message/message-dialog.vue";

  export default {
    components: {
      EmailBulkMessageDialog,
      SendListTable,
      QuickBulkMessage,
    },

    props: {
      indexUrl: String,
      createUrl: String,
      importUrl: String,
      canCreate: {
        type: Boolean,
        default: false
      },
			canSendMessage: {
				type: Boolean,
				default: false
			},
      canImport: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },

      /**
       * @return {undefined}
       */
      addSendList() {
        window.location = this.createUrl;
      },

      /**
       * @return {undefined}
       */
      onImport() {
        window.location = this.importUrl;
      },
    },

    created() {
      eventBus.$on('refresh-send-list-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-send-list-table', this.refresh);
    }
  }
</script>
